/** @format */

import * as React from 'react';
//@ts-ignore
import { StyleSheet, View } from 'react-native';
import Images from '../images';
//@ts-ignore
import { JDTouchable, JDDevice, JDText, JDImage } from '@jdreact/jdreact-core-lib';

import { Platform } from 'react-native';
const { getRpx, getFontSize } = JDDevice;
const styles = StyleSheet.create({
  wrap: {
    flexDirection: 'row',
    alignItems: 'center',
    width: getRpx(750),
    height: getRpx(334),
    backgroundColor: '#f7f7f7',
  },
  textBox: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: getRpx(103),
    height: getRpx(114),
  },
  framePlacehodler: {
    justifyContent: 'center',
    flexDirection: 'row',
    marginLeft: getRpx(51),
    width: getRpx(310),
    height: getRpx(310),
    borderWidth: 1,
    borderRadius: getRpx(12),
    borderColor: '#D7D7D7',
    borderStyle: 'dashed',
  },
  textPlacehodler: {
    fontSize: getFontSize(26),
    color: '#BFBFBF',
  },
  addBtnIcon: {
    width: getRpx(56),
    height: getRpx(56),
  },
});
interface props {
  golbalSku: string;
}
interface state {}
export default class AddGoodsPlaceholder extends React.PureComponent<props, state> {
  constructor(props: props) {
    super(props);
  }
  render() {
    return (
      <View style={styles.wrap}>
        <View style={styles.framePlacehodler}>
          <View style={styles.textBox}>
            <JDImage source={Images.contrast.placeholderBtn} style={styles.addBtnIcon}></JDImage>
            <JDText style={styles.textPlacehodler}>添加对比的商品</JDText>
          </View>
        </View>
      </View>
    );
  }
}
